import o from "./highrise239.mjs";
/* empty css             */
import t from "./highrise181.mjs";
const _ = /* @__PURE__ */ t(o, [["__scopeId", "data-v-2c17482d"]]);
export {
  _ as default
};
